import CreateCapsulePage from "pages/user/createCapsulePage";
import HomePage from "./pages/user/homePage";
import Dashboard from "pages/user/dashboard";
import ProfilePage from "./pages/user/profilePage";
import MasterLayout from "./pages/user/theme/masterLayout";
import MyCapsulePage from "pages/user/myCapsulePage";
import FriendPage from "./pages/user/friendPage";
import ResetPassword from "component/ResetPassword";
import { ROUTERS } from "./utils/router";
import { Routes, Route } from "react-router-dom";
import "./pages/user/theme/footer/style.scss"

const renderUserRouter = () => {
  return (
    <div className="backgroundColor">
      <MasterLayout>
        <Routes>
          <Route path={ROUTERS.USER.HOME} element={<HomePage />} />
          <Route path={ROUTERS.USER.PROFILE} element={<ProfilePage />} />
          <Route path={ROUTERS.USER.CREATE} element={<CreateCapsulePage />} />
          <Route path="/dashboard/:mode?" element={<Dashboard />} />
          <Route path="/my-capsule/:mode?" element={<MyCapsulePage />} />
          <Route path={ROUTERS.USER.FRIENDS} element={<FriendPage />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </Routes>
      </MasterLayout>
    </div>
  );
};
const RouterCustom = () => {
  return renderUserRouter();
};

export default RouterCustom;
